export default __webpack_public_path__ + "static/media/IDT-1-nosotros-569x349.f8d9ddef.webp";